import { Button, buttonClasses, styled } from '@mui/material';

const StyledButton = styled(Button)(({ theme }) => ({
    fontSize: '0.75rem',
    fontWeight: 400,
    padding: 0,
    '&:hover': {
        color: theme.palette.primary.main
    },
    [`.${ buttonClasses.startIcon } svg`]: {
        fontSize: '0.875rem'
    }
})) as typeof Button;

export default StyledButton;
